<main class="text-start">
  <h2 class="page-title">
    <a [routerLink]="['/orders']" class="text-[#8A8AA3] me-0.5 ms-2 hover:text-purple-800">
      <i class="bi" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i>
      {{ 'orders.details.back' | translate }}
    </a>
    {{ 'orders.details.title' | translate }}
  </h2>

  <div *ngIf="!order" class="bg-[#F6F6F6] rounded-md p-3.5 flex max-xl:flex-col xl:flex-row-reverse gap-5 animate-pulse">

    <div class="max-xl:w-full w-2/7 h-fit">

      <div class="w-full bg-white rounded-xl px-5 py-5 border-t-8 border-gray-200">
        <div class="flex justify-start gap-5">

          <div class="bg-gray-200 w-12 h-12 rounded-[1.2rem]"></div>

          <div class="flex-1 space-y-3">
            <div class="bg-gray-200 h-4 rounded w-24 me-auto"></div>
            <div class="bg-gray-200 h-3 rounded w-full"></div>
            <div class="bg-gray-200 h-3 rounded w-3/4"></div>
          </div>

        </div>
      </div>

      <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">
        <div class="bg-gray-200 h-4 rounded w-28 me-auto mb-5"></div>

        <div class="p-3 flex justify-start items-center gap-3">
          <div class="bg-gray-200 w-8 h-8 rounded-full"></div>
          <div class="bg-gray-200 h-4 rounded w-24"></div>
        </div>
      </div>

    </div>

    <div class="bg-white max-xl:w-full w-5/7 rounded-xl px-5 py-5">

      <div class="w-full flex max-md:flex-col justify-between md:items-center items-start gap-2 md:gap-0 mb-8">
        <div *ngFor="let _ of [1,2,3,4]" class="w-full flex flex-col items-start gap-2">
          <div class="bg-gray-200 h-3 w-full md:w-20 rounded"></div>
          <div class="bg-gray-200 h-4 w-full md:w-24 rounded"></div>
        </div>
      </div>


      <div class="space-y-4 mt-8">
        <div class="bg-gray-200 h-4 w-24 rounded me-auto"></div>

        <div class="flex flex-col md:flex-row justify-between items-center gap-2 border-2 border-gray-200 rounded-lg p-4 space-y-4">
          <div *ngFor="let _ of [1,2,3,4,5]" class="w-full flex flex-col gap-2">
            <div class="flex justify-start gap-2">
              <div class="bg-gray-200 h-3 w-3 rounded"></div>
              <div class="bg-gray-200 h-3 w-16 rounded"></div>
            </div>
            <div class="h-2 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>


      <div class="mt-8">
        <div class="bg-gray-200 h-4 rounded w-20 mb-4 me-auto"></div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div *ngFor="let _ of [1,2]" class="border-2 border-gray-200 rounded-lg p-3 flex items-center gap-3">
            <div class="w-14 h-14 bg-gray-200 rounded"></div>
            <div class="flex-1 space-y-2">
              <div class="bg-gray-200 h-4 rounded w-32"></div>
              <div class="bg-gray-200 h-3 rounded w-20"></div>
            </div>
          </div>
        </div>
      </div>


      <div class="mt-8">
        <div class="bg-gray-200 h-4 rounded w-24 mb-4 me-auto"></div>

        <div class="bg-[#F5F5F5] rounded-lg p-4 space-y-4">
          <div *ngFor="let _ of [1,2]"
            class="flex justify-between">
            <div class="bg-gray-200 h-4 w-16 rounded"></div>
            <div class="bg-gray-200 h-4 w-32 rounded"></div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="order" class="bg-[#F6F6F6] rounded-md p-3.5 flex max-xl:flex-col xl:flex-row-reverse max-xl:items-center gap-5">
    <!-- Note and User Details Section -->
    <div class="max-xl:w-full w-2/7 h-fit">
      <div class="w-full bg-white rounded-xl px-5 py-5 border-t-8 border-[#8280FF]">
        <div class="flex justify-start w-full gap-5">
          <div class="bg-[#E4E4FF] px-[15px] py-[10px] h-fit  rounded-[1.2rem] flex justify-center items-center">
            <i class="bi bi-journal-text text-xl text-[#8280FF]"></i>
          </div>
          <div>
            <p class="text-[#1F1F1F] font-semibold text-[0.8rem]">{{ 'orders.details.note' | translate }}</p>

            <p class="text-[#4B4B4B] text-xs">{{ order.note || ('orders.details.no_note' | translate) }}</p>
          </div>
        </div>
      </div>
      <!-- Customization Media -->
      <div *ngIf="customizationGroups.length" class="w-full bg-white rounded-xl mt-3 px-5 py-5 border-t-8 border-[#F472B6]">
        <div class="flex justify-start w-full gap-5">
          <div class="bg-[#FCE7F3] px-[15px] py-[10px] h-fit rounded-[1.2rem] flex justify-center items-center">
            <i class="bi bi-image text-xl text-[#EC4899]"></i>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-[#1F1F1F] font-semibold text-[0.8rem]">{{ 'orders.details.customization.title' | translate }}</p>
            <p class="text-[#8E8E8E] text-[0.7rem] mt-0.5">{{ 'orders.details.customization.helper' | translate }}</p>
          </div>
        </div>

        <!-- One block per media group: the units that share a media set, with that
             set's media listed beneath. Spans the full card width. -->
        <div class="mt-3 space-y-2">
          <div *ngFor="let group of customizationGroups; trackBy: trackByIndex"
            class="bg-[#FAFAFA] border border-[#EFEFEF] rounded-lg p-2.5">
            <!-- group header: product + how many units share this media set -->
            <div class="flex items-center justify-between gap-2">
              <p class="text-[#2F3541] text-xs font-medium truncate">{{ group.productName }}</p>
              <span class="bg-[#FCE7F3] text-[#EC4899] text-[0.65rem] font-semibold px-1.5 py-0.5 rounded-full shrink-0">
                {{ group.quantity }} {{ (group.quantity === 1 ? 'orders.details.customization.unit_singular' : 'orders.details.customization.unit_plural') | translate }}
              </span>
            </div>

            <!-- the media that make up this group -->
            <div class="mt-2 space-y-1.5">
              <div *ngFor="let attachment of group.attachments; trackBy: trackByIndex"
                class="flex items-center justify-between gap-2 border border-[#EFEFEF] rounded-md px-2 py-1.5">
                <div class="flex items-center gap-2 min-w-0">
                  <i class="bi text-sm text-[#EC4899] shrink-0" [ngClass]="mediaIcon(attachment.type)"></i>
                  <!-- text customization shows its content inline; other media show their type -->
                  <p *ngIf="attachment.type === 'text'" dir="auto" class="text-[#6C6C89] text-[0.7rem] truncate">{{ attachment.text_content }}</p>
                  <p *ngIf="attachment.type !== 'text'" class="text-[#6C6C89] text-[0.7rem] truncate">{{ ('orders.details.customization.types.' + attachment.type) | translate }}</p>
                </div>

                <!-- actions: download (file media) / copy (text) + preview popup (all) -->
                <div class="flex items-center gap-1 shrink-0">
                  <button *ngIf="attachment.type !== 'text'" type="button" (click)="downloadAttachment(attachment)" [title]="'orders.details.customization.download' | translate"
                    class="bg-[#F4F4F6] hover:bg-gray-200 transition-colors rounded-md px-1.5 py-0.5 leading-none text-[#4B4B4B] cursor-pointer">
                    <i class="bi bi-download text-xs"></i>
                  </button>
                  <button *ngIf="attachment.type === 'text'" type="button" (click)="copyAttachmentText(attachment)" [title]="'orders.details.customization.copy' | translate"
                    class="bg-[#F4F4F6] hover:bg-gray-200 transition-colors rounded-md px-1.5 py-0.5 leading-none cursor-pointer"
                    [ngClass]="copiedAttachmentId === attachment.id ? 'text-green-600' : 'text-[#4B4B4B]'">
                    <i class="bi text-xs transition-transform" [ngClass]="copiedAttachmentId === attachment.id ? 'bi-clipboard-check scale-110' : 'bi-clipboard'"></i>
                  </button>
                  <button type="button" (click)="openAttachmentPreview(attachment)" [title]="'orders.details.customization.view' | translate"
                    class="bg-[#F4F4F6] hover:bg-gray-200 transition-colors rounded-md px-1.5 py-0.5 leading-none text-[#4B4B4B] cursor-pointer">
                    <i class="bi bi-eye text-xs"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">
        <p class="text-[#1F1F1F] font-semibold text-sm">{{ 'orders.details.user_details' | translate }}</p>

        <div class="p-3 flex justify-start items-center gap-2">
          <div class="bg-[#FCC5F3] w-8 h-8 rounded-full">
            <img src="dashboard/place-holders/avatar-female.png" class="w-8 h-8 rounded-full" alt="">
          </div>
          <span class="text-[#2F3541] text-sm"> {{ order.name }} </span>
        </div>
      </div>
    </div>

    <div class="bg-white max-xl:w-full w-5/7 rounded-xl p-4 -space-y-0.5" [ngStyle]="{ 'container-type': 'inline-size' }">

      <div class="w-full flex max-md:flex-col justify-between md:items-center items-start gap-2 md:gap-0 text-sm">
        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.invoice_number' | translate }}</p>
          <p class="header-sub-details">#{{ order.order_uuid | slice:0:8 }}</p>
        </div>

        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.placed_at' | translate }}</p>
          <p class="header-sub-details" dir="ltr">{{ order.placed_at | date: 'dd MMM / hh:mm a' }}</p>
        </div>

        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.expected_delivery' | translate }}</p>
          <p class="header-sub-details" dir="ltr">{{ (order.scheduled_for ? order.scheduled_for : order.estimated_ship_datetime)| date: 'short' }}</p>
        </div>

        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.status' | translate }}</p>
          <p [ngClass]="{
                  'bg-purple-100 text-purple-700': order.status === 'preparing_order',
                  'bg-blue-100 text-blue-700': order.status === 'placed',
                  'bg-emerald-100 text-emerald-700': order.status === 'ready_for_pickup',
                  'bg-yellow-100 text-yellow-700': order.status === 'out_for_delivery',
                  'bg-green-100 text-green-700': order.status === 'delivered',
                  'bg-red-100 text-red-700': order.status === 'cancelled' || order.status === 'rejected',
                  'bg-rose-100 text-rose-700': order.status === 'refunded'
                }" class="py-1 px-2 rounded-md text-[10px] font-medium text-xs">

            {{ ('orders.statuses.' + order.status) | translate }}
          </p>
        </div>

      </div>

      <!-- Order Status Section -->
      <div class="flex flex-col gap-3 mt-8">
        <p class="font-semibold text-[#4B4B4B] text-xs">{{ 'orders.details.progress.section_title' | translate }}</p>
        <div
          class="border-[1.5px] border-[#ededed] rounded-lg flex flex-col @2xl:flex-row items-center gap-3.5 justify-center w-full px-3 py-4">
          <div class="w-full text-xs">
            <p class="ms-1 flex items-center justify-start gap-2 text-gray-600">
              <i class="bi bi-alarm text-sm"></i>
              {{ 'orders.details.progress.placed' | translate }}
            </p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'placed' ? 'bg-blue-500' : 'bg-green-500'" [style.width.%]="100"></div>
            </div>
          </div>
          <div class="w-full text-xs">
            <p class="ms-1 flex items-center justify-start gap-2 text-gray-600"> <i class="bi bi-box2 text-sm"></i> {{ 'orders.details.progress.preparing_order' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'preparing_order' ? 'bg-blue-500' : order.status === 'ready_for_pickup' || order.status === 'out_for_delivery' || order.status === 'delivered' ? 'bg-green-500' : ''"
                [style.width.%]="100"></div>
            </div>
          </div>
          <div class="w-full text-xs">
            <p class="ms-1 flex items-center justify-start gap-2 text-gray-600"> <i class="bi bi-box2-heart text-sm"></i> {{ 'orders.details.progress.ready_for_pickup' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'ready_for_pickup' ? 'bg-blue-500' : order.status === 'out_for_delivery' || order.status === 'delivered' ? 'bg-green-500' : ''"
                [style.width.%]="100"></div>
            </div>
          </div>
          <div class="w-full text-xs">
            <p class="ms-1 flex items-center justify-start gap-2 text-gray-600"> <i class="bi bi-truck text-sm"></i> {{ 'orders.details.progress.out_for_delivery' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'out_for_delivery' ? 'bg-blue-500' : order.status === 'delivered' ? 'bg-green-500' : ''"
                [style.width.%]="100"></div>
            </div>
          </div>
          <div class="w-full text-xs">
            <p class="ms-1 flex items-center justify-start gap-2 text-gray-600"> <i class="bi bi-clipboard-check text-sm"></i> {{ 'orders.details.progress.delivered' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'delivered' ? 'bg-green-500':''"
                [style.width.%]="100"></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="order.status == 'placed' || order.status == 'preparing_order'" class="bg-[#F7F7F8] flex flex-col gap-3 p-3.5 border-s-2 border-[#7047EB] font-medium mt-8">
        <p class="text-[#121217] text-xs"><i class="bi bi-info-circle-fill text-[#7047EB] me-2 text-sm"></i> {{ 'orders.details.actions.change_status' | translate }}</p>
        <p class="text-[#6C6C89] text-xs ms-6">
          {{ 'orders.details.info.vendor_change_status_help' | translate }}

          <a [href]="`https://wa.me/962770684544?text=${whatsappText}`" class="text-black">
            {{ 'orders.details.info.raise_issue_link' | translate }}
          </a>

        </p>

        <div class="flex justify-start items-center gap-3">
          <button class="flex items-center gap-2 text-[#121217] bg-white px-3 py-1 text-xs border rounded-md border-[#D1D1DB] cursor-pointer disabled:opacity-50" [disabled]="isUpdateStatus || isRejecting" (click)="updateOrderStatus()">
            {{ 'orders.details.actions.next_stage' | translate }}
            <ng-container *ngIf="isUpdateStatus">
              <div class="w-3.5 h-3.5 border-2 border-gray-300 border-t-black rounded-full animate-spin"></div>
            </ng-container>
          </button>
          <button *ngIf="order.status === 'placed'" class="flex items-center gap-2 text-red-600 bg-white px-3 py-1 text-xs border rounded-md border-red-300 cursor-pointer disabled:opacity-50" [disabled]="isUpdateStatus || isRejecting" (click)="rejectOrder()">
            {{ 'orders.details.actions.reject' | translate }}
            <ng-container *ngIf="isRejecting">
              <div class="w-3.5 h-3.5 border-2 border-red-200 border-t-red-600 rounded-full animate-spin"></div>
            </ng-container>
          </button>
        </div>
      </div>

      <div
        class="font-semibold text-[#4B4B4B] my-3 flex justify-start items-center gap-2 mt-8 text-xs">
        <div>{{ order.items.length }}</div>
        <div>{{ (order.items.length === 1 ? 'orders.details.items_count_singular' : 'orders.details.items_count_plural') | translate }}</div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3.5">
        <div *ngFor="let item of order.items"
          class="border border-[#d3d3d3] rounded-lg flex items-center gap-3.5 justify-start p-2">
          <div class="p-2 bg-[#F6F6F6] rounded-md">
            <img [src]="item.variant.images[0].image" class="w-10 h-10 object-contain" />
          </div>
          <div class="flex-1 flex flex-col gap-1">
            <div>
              <p class="text-xs font-medium">{{ item.product_name || item.variant.name }}</p>
              <p *ngIf="item.product_name && item.variant.name !== item.product_name" class="text-[11px] text-[#8E8E8E]">{{ item.variant.name }}</p>
            </div>

            <div class="flex justify-between items-center text-[11px]">
              <p class="text-[#8E8E8E]">{{ 'orders.details.qty_label' | translate }} : {{ item.quantity }}</p>
              <p>{{ item.price }} {{ 'common.currency' | translate }}</p>
            </div>
          </div>
        </div>
      </div>


      <p class="font-semibold text-[#4B4B4B] mt-8 text-xs">{{ 'orders.details.summary' | translate }}</p>

      <div class="bg-[#F5F5F5] p-3.5 rounded-lg mt-3.5 text-xs">
        <div *ngFor="let item of order.items" class="flex justify-between items-start gap-2 text-[#2F3541] text-xs mb-5">
          <p class="text-xs text-[#2F3541] font-medium flex items-start gap-2">
            <span>
              {{ item.product_name || item.variant.name }}
              <span *ngIf="item.product_name && item.variant.name !== item.product_name" class="text-[#6B7280] font-normal">— {{ item.variant.name }}</span>
            </span>
            <span class="inline-block bg-gray-200 text-gray-700 px-2 py-0.5 rounded-md text-xs font-semibold shrink-0">
              {{ item.quantity }} x
            </span>
          </p>
          <p class="shrink-0">{{ item.price * item.quantity }} {{ 'common.currency' | translate }}</p>
        </div>

        <div class="flex justify-between items-center text-[#363636] font-semibold text-xs">
          <p>{{ 'orders.details.total' | translate }}</p>
          <p>{{ totalOrderPrice }} {{ 'common.currency' | translate }}</p>
        </div>
      </div>

    </div>
  </div>

  <!-- Attachment preview popup -->
  <div *ngIf="previewAttachment" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" (click)="closeAttachmentPreview()">
    <div class="bg-white rounded-xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden text-start" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between gap-2 px-4 py-3 border-b border-[#EFEFEF]">
        <p class="text-[#1F1F1F] font-semibold text-sm flex items-center gap-2 min-w-0">
          <i class="bi text-[#EC4899] shrink-0" [ngClass]="mediaIcon(previewAttachment.type)"></i>
          <span class="truncate">{{ ('orders.details.customization.types.' + previewAttachment.type) | translate }}</span>
        </p>
        <button type="button" (click)="closeAttachmentPreview()" class="text-[#4B4B4B] hover:text-black cursor-pointer shrink-0">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="p-4 overflow-auto">
        <img *ngIf="previewAttachment.type === 'image'" [src]="previewAttachment.file" class="max-w-full max-h-[50vh] object-contain mx-auto rounded-lg" alt="" />
        <video *ngIf="previewAttachment.type === 'video'" [src]="previewAttachment.file" controls class="max-w-full max-h-[50vh] mx-auto rounded-lg"></video>
        <audio *ngIf="previewAttachment.type === 'audio'" [src]="previewAttachment.file" controls class="w-full"></audio>
        <p *ngIf="previewAttachment.type === 'text'" dir="auto" class="text-[#2F3541] text-sm whitespace-pre-wrap break-words">{{ previewAttachment.text_content }}</p>
      </div>

      <div class="px-4 py-3 border-t border-[#EFEFEF] flex justify-end">
        <button *ngIf="previewAttachment.type !== 'text'" type="button" (click)="downloadAttachment(previewAttachment)"
          class="flex items-center gap-2 bg-[#611F79] hover:bg-purple-800 transition-colors text-white text-xs px-3 py-2 rounded-md cursor-pointer">
          <i class="bi bi-download"></i>
          {{ 'orders.details.customization.download' | translate }}
        </button>
        <button *ngIf="previewAttachment.type === 'text'" type="button" (click)="copyAttachmentText(previewAttachment)"
          class="flex items-center gap-2 bg-[#611F79] hover:bg-purple-800 transition-colors text-white text-xs px-3 py-2 rounded-md cursor-pointer">
          <i class="bi" [ngClass]="copiedAttachmentId === previewAttachment.id ? 'bi-clipboard-check' : 'bi-clipboard'"></i>
          {{ (copiedAttachmentId === previewAttachment.id ? 'orders.details.customization.copied' : 'orders.details.customization.copy') | translate }}
        </button>
      </div>
    </div>
  </div>
</main>
